import { combineReducers } from 'redux';
import { createResponsiveStateReducer } from 'redux-responsive';

/* reducers from features/ */
import dashboardReducer from 'src/ui/features/Dashboard/state/dashboardReducer';
import documentsReducer from 'src/ui/features/Documents/state/documentsReducer';
import consentReducer from 'src/ui/features/Consent/state/consentReducer';
import loginReducer from 'src/ui/features/Login/state/loginReducer';
import messagingReducer from 'src/ui/features/Messaging/state/messagingReducer';
import casesReducer from 'src/ui/features/Cases/state/casesReducer';
import serviceInitReducer from 'src/ui/features/ServiceInit/state/serviceInitReducer';
import utilsReducer from 'src/utils/utilsReducer.js';
import tasksReducer from 'src/ui/features/Tasks/state/tasksReducer';
import employeesReducer from 'src/ui/features/Employees/state/employeesReducer';
import profileReducer from 'src/ui/features/Profile/state/profileReducer';
import whatIfReducer from 'src/ui/features/WhatIf/state/whatIfReducer';
import caseDataCollectReducer from 'src/new-ui/features/CaseDataCollect/state/caseDataCollectReducer';
import newDashboardReducer from 'src/new-ui/features/NewDashboard/state/newDashboardReducer';

const rootReducer = routerReducer =>
  combineReducers({
    router: routerReducer,
    dashboard: dashboardReducer,
    documents: documentsReducer,
    consent: consentReducer,
    login: loginReducer,
    messaging: messagingReducer,
    cases: casesReducer,
    serviceInit: serviceInitReducer,
    browser: createResponsiveStateReducer({
      extraSmall: 480,
      small: 600,
      medium: 960,
      large: 1280,
      extraLarge: 1920,
    }),
    utils: utilsReducer,
    tasks: tasksReducer,
    employees: employeesReducer,
    profile: profileReducer,
    whatIf: whatIfReducer,
    caseDatacollectMenu: caseDataCollectReducer,
    newDashboard: newDashboardReducer,
  });

export default rootReducer;
